/**
 * 应用卡片分享
 */
import React, { useCallback, useMemo } from "react";
import lodashGet from "lodash/get";
import bus from "@/utils/bus";
import styles from "./sharehots.module.less";
import hotBg from "../../../assets/images/im/icons-ai-hots.png";
import { connect } from "dvajs";
import { ChatMessage, ChatMessageType } from "@/types/chat";
import { initChatMessageInfo } from "@/utils/chat/message";

interface IProps {
  message: any;
  selectedSession: any;
  currentEmployee: any;
  pushChatMessage: Function;
}

function ShareHotsCard(props: IProps) {
  const { message, selectedSession, currentEmployee, pushChatMessage } = props;
  const dataInfos = lodashGet(message, "data", []);

  const buildMessage = useCallback(
    (content: string, opts: any) => {
      const messageBody = {
        type: ChatMessageType.TEXT,
        ...opts,
        content,
        question: content,
        isMyself: true
      };
      const message: Partial<ChatMessage> = initChatMessageInfo({
        selectedSession,
        currentEmployee,
        message: messageBody
      });
      return message;
    },
    [currentEmployee, selectedSession]
  );

  const handleClick = useCallback(
    (data: any) => {
      if (data) {
        const message = buildMessage(data, {});
        pushChatMessage({ sessionId: selectedSession.sessionId, message });
      }
    },
    [buildMessage, pushChatMessage, selectedSession.sessionId]
  );

  return (
    <div className={styles["share-hots-wrap"]}>
      <div className={styles["title-wrap"]}>
        <img src={hotBg} className={styles["icon"]} />
        <span className={styles["text"]}>热门提问</span>
      </div>
      <div className={styles["content"]}>
        {dataInfos.map((item: any, idx: number) => {
          return (
            <div
              className={styles["item"]}
              key={`share-hots_${idx}`}
              onClick={() => handleClick(item)}
            >
              <span className={`${styles["text"]} ellipsis`}>{item}</span>
              <span className={styles["link"]}>我要问</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function mapStateToProps({ chat }: any) {
  return {
    selectedSession: chat.selectedSession,
    currentEmployee: chat.currentEmployee,
    llmSetting: chat.llmSetting
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    pushChatMessage (data: { sessionId: string; message: Partial<ChatMessage> }) {
      dispatch({ type: "chat/pushChatMessage", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ShareHotsCard);
